import * as React from 'react';
import type { SVGProps } from 'react';

const SvgFilterSign = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={15} height={10} fill="none" {...props}>
    <path
      fill="#545B69"
      d="M6.667 10h1.666a.836.836 0 0 0 .834-.833.836.836 0 0 0-.834-.834H6.667a.836.836 0 0 0-.834.834c0 .458.375.833.834.833ZM0 .833c0 .459.375.834.833.834h13.334A.836.836 0 0 0 15 .833.836.836 0 0 0 14.167 0H.833A.836.836 0 0 0 0 .833Zm3.333 5h8.334A.836.836 0 0 0 12.5 5a.836.836 0 0 0-.833-.833H3.333A.836.836 0 0 0 2.5 5c0 .458.375.833.833.833Z"
    />
  </svg>
);
export default SvgFilterSign;
